<div class="rule-dialog">
  <div class="dialog-header">
    <span>Bonus Wallet</span>
    <cs-icon-button
      class="btn-close"
      iconType="icon"
      icon="fi-x"
      color="secondary"
      size="12"
      (buttonClick)="close()"
    ></cs-icon-button>
  </div>
  <div class="dialog-content" [appLoading]="loading">
    @if (!loading) {
      <div class="locked-bonuses">
        <div class="item">
          <div class="name">Total bonus wallet balance</div>
          <div class="amount">
            <span>{{ data.lockedBonusAmount | currencyValue: 'USDT' }}</span>
            <img [src]="'USDT' | currencyIcon" alt="" />
          </div>
        </div>
        <div class="line"></div>
        @for (item of lockedBonusAmountDetail; track item; let idx = $index, count = $count) {
          <div class="item">
            <div class="name">{{ item.name || 'no name' }}</div>
            <div class="amount">
              <span>{{ item.amount | currencyValue: item.currency }}</span>
              <img [src]="item.currency | currencyIcon" alt="" />
            </div>
          </div>
        }
      </div>
    }
  </div>
  <div class="dialog-btn">
    <cs-button class="close-btn" [height]="'48px'" [size]="'large'" [label]="'Close'" (buttonClick)="close()" />
  </div>
</div>
